import { useContent } from "../../context/ContentContext";
import { resolveUrl } from "../../lib/media";
import { Reveal } from "./Reveal";

export const Partners = () => {
  const { content } = useContent();
  const p = content.partners;
  if (!p || p.enabled === false) return null;
  const items = (p.items || []).filter((it) => it && it.enabled !== false && (it.name || it.logo));
  if (items.length === 0) return null;
  return (
    <section className="bg-[#050505] py-20 border-t border-white/10" data-testid="partners-section">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <Reveal className="mb-12 flex items-center gap-3 justify-center">
          <span className="h-px w-10 bg-electric" />
          <span className="text-xs tracking-[0.35em] uppercase text-electric">{p.eyebrow}</span>
          <span className="h-px w-10 bg-electric" />
        </Reveal>
        <div className="flex flex-wrap items-center justify-center gap-x-14 gap-y-10">
          {items.map((it, i) => {
            const inner = it.logo
              ? <div className="h-14 w-36 flex items-center justify-center"><img src={resolveUrl(it.logo)} alt={it.name} className="max-h-14 max-w-full w-auto object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300" /></div>
              : <span className="font-serif text-2xl text-white/50 hover:text-white transition-colors">{it.name}</span>;
            return (
              <Reveal key={i} delay={i * 0.06}>
                {it.url ? <a href={it.url} target="_blank" rel="noreferrer" data-testid={`partner-${i}`} title={it.name}>{inner}</a> : <div data-testid={`partner-${i}`}>{inner}</div>}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
